/* RESET — theme JS */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- Reveal ---- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  $$('.rv').forEach(function (el) { io.observe(el); });

  /* ---- Contador (fecha real) ---- */
  $$('[data-deadline]').forEach(function (el) {
    var fin = new Date(el.dataset.deadline).getTime();
    if (isNaN(fin)) { el.style.display = 'none'; return; }
    (function tick() {
      var d = fin - Date.now();
      if (d <= 0) { el.textContent = ''; return; }
      var h = Math.floor(d / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1000);
      el.textContent = 'Termina en ' + [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
      setTimeout(tick, 1000);
    })();
  });

  /* ---- Barra negra condensada ---- */
  var tbar = $('[data-tbar]'), tAnchor = $('[data-tbar-anchor]');
  if (tbar && tAnchor) {
    new IntersectionObserver(function (es) {
      tbar.classList.toggle('is-on', !es[0].isIntersecting);
    }, { rootMargin: '0px' }).observe(tAnchor);
  }

  /* ---- Barra fija de compra ---- */
  var sticky = $('[data-sticky]'), sAnchor = $('[data-sticky-anchor]');
  if (sticky) {
    if (sticky.hasAttribute('data-sticky-always')) {
      sticky.classList.add('is-on');
    } else if (sAnchor) {
      new IntersectionObserver(function (es) {
        sticky.classList.toggle('is-on', !es[0].isIntersecting);
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(sAnchor);
    } else { sticky.classList.add('is-on'); }
  }

  /* ---- Galería ---- */
  var main = $('[data-pdp-main]');
  if (main) {
    $$('[data-pdp-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.full;
        $$('[data-pdp-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
      });
    });
  }

  /* ---- Producto: modo, packs, upsell, cantidad ---- */
  var form = $('[data-product-form]');
  if (form) {
    var hidden = $('[data-variant-id]', form);
    var sPrice = $('[data-sticky-price]'), sCompare = $('[data-sticky-compare]');
    var qtyInput = $('[data-qty-input]');

    /* tarjetas de modo (solo bloque / con suscripción) */
    $$('[data-modo]').forEach(function (r) {
      r.addEventListener('change', function () {
        $$('[data-offer]').forEach(function (o) {
          o.classList.toggle('offer--on', o.dataset.offer === r.value);
        });
      });
    });

    /* packs */
    function pintarPack(r) {
      hidden.value = r.dataset.variant;
      if (sPrice) sPrice.textContent = r.dataset.price;
      if (sCompare) sCompare.textContent = r.dataset.compare || '';
      $$('[data-tier]').forEach(function (t) {
        t.classList.toggle('tier--on', t.contains(r));
      });
    }
    $$('input[name="pack"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) pintarPack(r); });
    });

    /* cantidad */
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = parseInt(qtyInput.value, 10) + parseInt(b.dataset.qty, 10);
        qtyInput.value = Math.max(1, n);
      });
    });

    /* envío: agrega el upsell al carrito antes de mandar el principal */
    form.addEventListener('submit', function (e) {
      var up = $('[data-upsell]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var qField = form.querySelector('input[name="quantity"]');
      if (!qField) {
        qField = document.createElement('input');
        qField.type = 'hidden'; qField.name = 'quantity';
        form.appendChild(qField);
      }
      qField.value = qty;

      if (up && up.checked && !form.dataset.upsellDone) {
        e.preventDefault();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(up.value), quantity: 1 }] })
        }).catch(function () {}).then(function () {
          form.dataset.upsellDone = '1';
          form.submit();
        });
      }
    });

    var sBtn = $('[data-sticky-submit]');
    if (sBtn) sBtn.addEventListener('click', function () { form.requestSubmit(); });
  }

  /* ---- Videos ---- */
  $$('[data-video]').forEach(function (card) {
    var vid = $('[data-video-el]', card), btn = $('[data-video-btn]', card);
    if (!vid || !btn) return;
    btn.addEventListener('click', function () {
      if (vid.paused) { vid.play(); btn.style.opacity = '0'; }
      else { vid.pause(); btn.style.opacity = '1'; }
    });
    vid.addEventListener('ended', function () { btn.style.opacity = '1'; });
  });


  /* ---- PDP: pestañas ---- */
  $$('[data-tabs]').forEach(function (box) {
    $$('[data-tab]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-tab]', box).forEach(function (o) { o.classList.toggle('is-on', o === b); });
        $$('[data-panel]', box).forEach(function (p) { p.classList.toggle('is-on', p.dataset.panel === b.dataset.tab); });
      });
    });
  });

  /* ---- PDP: demo con acordeón ---- */
  $$('[data-demo-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = b.dataset.demoStep;
      $$('[data-demo-step]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
      $$('[data-demo-slot]').forEach(function (s) {
        var on = s.dataset.demoSlot === i;
        s.classList.toggle('is-on', on);
        var v = $('[data-demo-video]', s);
        if (v) { on ? v.play().catch(function () {}) : v.pause(); }
      });
    });
  });

  /* ---- PDP: funciones ---- */
  $$('[data-fx-b]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = b.dataset.fxB;
      $$('[data-fx-b]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
      $$('[data-fx-p]').forEach(function (p) { p.classList.toggle('is-on', p.dataset.fxP === i); });
      var det = $('[data-fx-p].is-on');
      if (det && !reduce) det.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });
  var primeraFx = $('[data-fx-b]');
  if (primeraFx) primeraFx.classList.add('is-on');

  /* ---- PDP: filtros de reseñas ---- */
  $$('[data-rev-f]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = b.dataset.revF;
      $$('[data-rev-f]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
      $$('[data-rev-t]').forEach(function (c) {
        c.hidden = !(f === 'all' || c.dataset.revT === f);
      });
    });
  });

  /* ---- Toast de compras ---- */
  var toast = $('[data-toast]'), datos = $('[data-toast-data]');
  if (toast && datos) {
    var lista = [];
    try { lista = JSON.parse(datos.textContent); } catch (e) {}
    if (lista.length && !reduce) {
      var i = 0, cerrado = false;
      var img = $('[data-toast-img]', toast), txt = $('[data-toast-txt]', toast);
      $('[data-toast-x]', toast).addEventListener('click', function () {
        cerrado = true; toast.classList.remove('is-on');
      });
      var cada = (parseInt(toast.dataset.interval, 10) || 18) * 1000;
      function mostrar() {
        if (cerrado) return;
        var d = lista[i % lista.length]; i++;
        if (d.img) { img.src = d.img; img.style.display = ''; } else { img.style.display = 'none'; }
        txt.innerHTML = '<b>' + d.n + '</b> de ' + d.c + '<br>compró ' + d.p + ' · ' + d.t;
        toast.classList.add('is-on');
        setTimeout(function () { toast.classList.remove('is-on'); }, 6500);
        setTimeout(mostrar, cada);
      }
      setTimeout(mostrar, 6000);
    }
  }
})();
